<template>
    <div class="project-cont-phone">
        <h2>{{tit}}</h2>
        <h4>{{subheading}}</h4>
        <div class="dec">
            <span>
                {{msg}}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProjectContPhone",

        data(){
            return {
                // title:''
            }

        },
        props:{
            tit:String,
            msg: String,
            subheading: String
        }
    }

</script>

<style lang="less">


        .project-cont-phone {
            h2 {
                font-size: 24px;
            }

            h4 {
                font-size: 16px;
                margin-bottom:10px;
                font-weight:normal;
            }

            .dec {
                text-align: left;
                font-size: 12px;
                margin-bottom:30px;

                span {
                    display: inline-block;
                    line-height: 2;
                    white-space: pre-wrap;   /*这是重点。文本换行*/
                }
            }
        }

        .appoint-box {
            width: 100%;
            margin-top: 50px;
        }
</style>